import { render, staticRenderFns } from "./OvopRanking.vue?vue&type=template&id=4fced666&scoped=true&"
import script from "./OvopRanking.vue?vue&type=script&lang=js&"
export * from "./OvopRanking.vue?vue&type=script&lang=js&"
import style0 from "./OvopRanking.vue?vue&type=style&index=0&id=4fced666&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fced666",
  null
  
)

export default component.exports